import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegistruComponent } from './registru.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
    declarations: [
        RegistruComponent
    ],
    imports: [
        CommonModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    exports: [RegistruComponent]
})
export class RegistruModule { }
